<script setup lang="ts">
import {onMounted} from "vue";
import {useFormatStore} from "@/stores/formatStore";
import {usePageStore} from "@/stores/pageStore";
import {useI18n} from "vue-i18n";

const {t} = useI18n(); // Import the translation function

const props = defineProps({
  slug: String
})

const pageStore = usePageStore()
const formatStore = useFormatStore();

onMounted(() => {
  pageStore.getAll(props.slug)
})

</script>
<template>

  <div class="w-full">
    <!-- Desktop -->
  <div class="hidden md:block w-full" v-show="!pageStore.loading">
    <div class="flex items-end justify-between">
      <span class="responsive-title-2">{{ t('travelInspiration.title') }}</span>
      <router-link
          :to="`/${$i18n.locale}/blog`"
          class="responsive-body-small font-bold underline"
          v-if="pageStore.pageList.length > 1"
      >
        {{ t('travelInspiration.findMore') }}
      </router-link>
    </div>

    <div class="grid grid-cols-5 gap-6 pt-8" v-if="pageStore.firstPage">
      <!-- First Div (3/5 width) -->
      <div class="col-span-3 flex gap-6">
        <router-link
            class="flex max-w-[550px] w-full"
            :to="`/${$i18n.locale}/page/${props.slug}/${pageStore.firstPage.slug}`"
        >
          <img
              :src="pageStore.firstPage.imageSet['1140w']"
              :alt="pageStore.firstPage.title"
              class="h-[360px] object-cover rounded-2xl w-full border-2 border-primary-blue"
          />
        </router-link>
        <div class="flex flex-col justify-between w-2/5">
          <div class="flex flex-col gap-3">
        <span class="responsive-body-small text-gray-500">
          {{
            formatStore.formatDateWithCustomPatternMapping(
                pageStore.firstPage.publishedAt,
                'MMM DD, YYYY'
            )
          }}
        </span>
            <span class="responsive-title-3 font-semibold line-clamp-3">
          {{ pageStore.firstPage.title }}
        </span>
            <span class="responsive-body-small text-gray-500">
          {{ pageStore.firstPage.seoDescription }}
        </span>
          </div>
          <router-link
              :to="`/${$i18n.locale}/page/${props.slug}/${pageStore.firstPage.slug}`"
              class="bg-primary-blue w-fit rounded-2xl px-5 py-2 flex shadow-md transition transform hover:scale-110"
          >
            <img
                src="@/assets/icons/svg/Arrow_right_white_16x16.svg"
                alt="arrow"
            />
          </router-link>
        </div>
      </div>

      <!-- Second and Third Divs (1/5 each) -->
      <div v-for="(page, index) in pageStore.pageList.slice(0, 2)" :key="index" class="flex flex-col col-span-1 gap-6">
        <router-link :to="`/${$i18n.locale}/page/${props.slug}/${page.slug}`" class="flex flex-col gap-1">
          <img
              :src="page.imageSet['570w']"
              :alt="page.title"
              class="w-full h-[180px] object-cover rounded-2xl border border-gray-300"
          />
          <span class="responsive-body-small text-gray-500 mt-2">
        {{
              formatStore.formatDateWithCustomPatternMapping(
                  page.publishedAt,
                  'MMM DD, YYYY'
              )
            }}
      </span>
          <span class="responsive-body-large font-semibold line-clamp-3">
        {{ page.title }}
      </span>
        </router-link>
      </div>
    </div>
  </div>
    <!-- Mobile -->
  <div class="travel-inspirations__grid mobile flex flex-col gap-8 mt-4 md:hidden visible">
    <span class="responsive-title-1 title-pagelist">{{ t('travelInspiration.title') }}</span>
    <!-- Scrolling Section -->
    <div class="flex gap-5 overflow-x-auto">
      <div
          v-for="page in pageStore.pageList"
          :key="page.id"
          class="flex flex-col gap-2 min-w-[320px]"
      >
        <router-link :to="`/${$i18n.locale}/page/${props.slug}/${page.slug}`">
          <div class="aspect-w-4 h-60 mb-2">
            <img
                :src="page.imageSet['760w']"
                :alt="page.title"
                class="w-full h-full object-cover rounded-2xl"
            />
          </div>
          <span class="responsive-body-xsmall text-gray-500 mt-2">
          {{
              formatStore.formatDateWithCustomPatternMapping(page.publishedAt, 'MMM DD, YYYY')
            }}
        </span>
          <h4 class="text-base font-semibold line-clamp-3">
            {{ page.title }}
          </h4>
        </router-link>
      </div>
    </div>
    <!-- "Find More Articles" Link -->
    <router-link
        :to="`/${$i18n.locale}/blog`"
        class=" responsive-link-small underline font-bold"
        v-if="pageStore.pageList.length > 1"
    >{{ t('travelInspiration.findMore') }}
    </router-link>
  </div>
  </div>
</template>

